// extracted by mini-css-extract-plugin
module.exports = {"queryBox":"QueryBox-module--query-box--isgH9","primary":"QueryBox-module--primary--12fJw","secondary":"QueryBox-module--secondary--3Exl7"};